module.exports = __webpack_public_path__ + "static/media/flria shot 15-mobile.a2f7b2d4.webp";